import { render, staticRenderFns } from "./VideodeurbelveiligHome.vue?vue&type=template&id=0655f6cb"
import script from "./VideodeurbelveiligHome.vue?vue&type=script&lang=js"
export * from "./VideodeurbelveiligHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports